import { createFileRoute } from "@tanstack/react-router";

import NotFound from "../pages/NotFound";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/$")({
  component: NotFoundRoute,
});

function NotFoundRoute() {
  return (
    <RequireAuth>
      <NotFound />
    </RequireAuth>
  );
}
